import { Component, OnInit, ViewChild } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { MdbTabChange, MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { finalize, Observable } from 'rxjs';
import { IListingSearchFilter } from 'src/app/components/main-body/interface';
import { HOLISTA_CONSTANT } from 'src/app/constants';
import { IAdaptedSearchProviderResponse, IFacilityAssociatedPhysicians, IPhysicianAssociatedFacilitiesResponse } from 'src/app/interfaces';
import { IListResponse, IResponse } from 'src/app/interfaces/http-interface';
import { MainService } from 'src/app/services';
import { HolistaUtils, LocationUtils } from 'src/app/utils';

@Component({
  selector: 'app-detail-modal',
  templateUrl: './detail-modal.component.html',
  styleUrls: ['./detail-modal.component.scss'],
})
export class DetailModalComponent implements OnInit {
  providerData: IAdaptedSearchProviderResponse;
  listingSearchFilter: IListingSearchFilter;
  isSearchByProvider: boolean;
  DEFAULT_MILWAUKEE_COORDINATES = HOLISTA_CONSTANT.DEFAULT_LOCATION;
  @ViewChild('tabs') tabs!: MdbTabsComponent;
  providerList: any[] = [];
  serviceList: any[] = [];

  HOLISTA_CONSTANT = this._holistaUtils.deepClone(HOLISTA_CONSTANT);
  isLoading = {
    providerList: false,
    serviceList: false,
  };
  providerId: any;
  providerCode:string;
  subTitle: string;
  isSmallScreen: boolean = false;

  constructor(
    public modalRef: MdbModalRef<DetailModalComponent>,
    private _locationUtility: LocationUtils,
    private _mainService: MainService,
    public _holistaUtils: HolistaUtils
  ) {}

  ngOnInit(): void {
    console.log('providerData', this.providerData);
    this.isSmallScreen = window.innerWidth <= 676;
    this.providerCode = this.providerData.code;

    if (!this.isSearchByProvider) {
      this.subTitle = 'Physicians';
    } else {
      this.subTitle = 'Facilities';
    }
  }

  getDirection(provider: IAdaptedSearchProviderResponse) {
    if (provider?.facility?.address || provider?.physician?.address) {
      const { address } = provider?.facility || provider?.physician;
      let stringifiedAddress = '';
      if (address) {
        stringifiedAddress = Object.values(address)
          .filter((x) => x)
          .join(' ');
      }
      const {location} = this.listingSearchFilter;
      if (location.latitude && location.longitude) {
        const origin =  `${location.latitude},${location.longitude}`;
        this._locationUtility.getDirection(
          origin,
          `${stringifiedAddress}`
        );
      } else {
        this._locationUtility.getDirection('', `${stringifiedAddress}`);
      }
    }
  }

  onLinkClick(link: string, newTab?: boolean) {
    this._holistaUtils.customRedirect(link, newTab);
  }


  mapListingResponse(provider: IFacilityAssociatedPhysicians | IPhysicianAssociatedFacilitiesResponse) {
    const isPhysician = 'physician' in provider;
    const providerInfo = isPhysician
      ? (provider as IFacilityAssociatedPhysicians).physician
      : (provider as IPhysicianAssociatedFacilitiesResponse).facility;

    const name = isPhysician
      ? [providerInfo.physicianBasicInfo?.firstName, providerInfo.physicianBasicInfo?.middleName, providerInfo.physicianBasicInfo?.lastName].filter(Boolean).join(' ')
      : providerInfo.facilityBasicInfo?.displayName || providerInfo.facilityBasicInfo?.businessName;

    const primaryTaxonomy = providerInfo.taxonomies?.length
      ? [{ name: providerInfo.taxonomies[0].description }]
      : null;

    return {
      name,
      primaryTaxonomy,
      address: {
        addressLine1: providerInfo.addressLine1,
        addressLine2: providerInfo.addressLine2,
        city: providerInfo.city,
        state: providerInfo.state,
        zip: providerInfo.zip,
      },
    };
  }
  fetchProviderList() {
    this.providerList = [];
    this.isLoading.providerList = true;
    const _services: Observable<IResponse<IListResponse<IFacilityAssociatedPhysicians | IPhysicianAssociatedFacilitiesResponse>>> = !this.isSearchByProvider
      ? this._mainService.getFacilityPhysicians(this.providerCode, {
          networks: this.listingSearchFilter.networkCode,
          excludeTerminatedProviders: true
        })
      : this._mainService.getPhysicianFacilities(this.providerCode, {
          networks: this.listingSearchFilter.networkCode,
          excludeTerminatedProviders: true
        });
    _services
      .pipe(
        finalize(() => {
          this.isLoading.providerList = false;
        })
      )
      .subscribe({
        next: (response: IResponse<IListResponse<IFacilityAssociatedPhysicians | IPhysicianAssociatedFacilitiesResponse>>) => {
          if (response && response?.data?.rows?.length) {
            this.providerList = response.data.rows.map((x) => this.mapListingResponse(x));
          }
        },
        error: (error) => {
          console.log('Error getting physicians.', error);
        },
      });
  }

  fetchServiceList() {
    this.isLoading.serviceList = true;
    let params = {};
    if (!this.isSearchByProvider) {
      params = {
        networkCode: this.listingSearchFilter.networkCode,
      };
    } else {
      params = {
        networkCode: this.listingSearchFilter.networkCode,
      };
    }
    this._mainService
      .getAssociatedBundles(this.providerCode, params)
      .pipe(
        finalize(() => {
          this.isLoading.serviceList = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (response && response?.data?.rows?.length) {
            this.serviceList = response.data.rows
          }
        },
        error: (error) => {
          console.log('Error getting services.', error);
        },
      });
  }

  onTabChange(event: MdbTabChange): void {
    switch (event.index) {
      case 0:
        if (!this.providerList.length) this.fetchProviderList();
        break;
      case 1:
        if (!this.serviceList.length) this.fetchServiceList();
        break;
      default:
        break;
    }
  }

  getFullName(physician: any): string {
    return [physician?.firstName, physician?.middleName, physician?.lastName]
      .filter((namePart) => !!namePart)
      .join(' ');
  }
}
